import { Paper } from '@mui/material';
import { styled } from '@mui/material/styles';

export const KpiContainer = styled(Paper)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  padding: theme.spacing(3),
  borderRadius: theme.spacing(1),
  [theme.breakpoints.down('xsm')]: {
    flex: 'none',
    width: '100%',
  },
}));

export const KpiHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  [theme.breakpoints.down('xmd')]: {
    gap: theme.spacing(1),
  },
}));

export const KpiHeaderContent = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  gap: theme.spacing(1),
}));

export const Buttons = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
  '> button': {
    padding: 0,
  },
}));
